interface StatCardProps {
  label: string;
  value: string | number;
  icon: string;
  sub?: string;
}

export default function StatCard({ label, value, icon, sub }: StatCardProps) {
  return (
    <div className="bg-[#0d1529] border border-[#1e2d4a] rounded-xl p-6 flex items-start gap-4">
      <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#0a1628] text-[#4fc3f7] text-2xl shrink-0">
        <i className={icon}></i>
      </div>
      <div>
        <p className="text-[#5a7a9a] text-sm mb-1">{label}</p>
        <p className="text-white text-3xl font-bold tracking-tight">{value}</p>
        {sub && <p className="text-[#4fc3f7] text-xs mt-1">{sub}</p>}
      </div>
    </div>
  );
}
